import graphqlClient from '~/graphql/graphqlClient';
import {
  MutationCavernsReturnToSurfaceArgs,
  CavernsReturnToSurfaceResult,
} from 'dt-common/generated/graphql-types';

const mutation = `
mutation CavernsReturnToSurface($playerId: String!, $game_submode: String!) {
  cavernsReturnToSurface(playerId: $playerId, game_submode: $game_submode) {
    before_battle
    currency1
    currency2
    items_picked_up
    game_submode
    goldGains
    hero_roster
    inventory
    pdGains
    xpGains
    living_hero_handles
  }
}
`;

export default async function mutationCavernsReturnToSurface(
  args: MutationCavernsReturnToSurfaceArgs
) {
  return await graphqlClient.request<CavernsReturnToSurfaceResult>(
    'cavernsReturnToSurface',
    mutation,
    args
  );
}
